import { RouteConfig } from 'vue-router';

import { Rules as CaslRules } from '../../../back/src/casl/casl.constants';

import PedidosSapIndex from '@/pages/pedidos-sap/PedidosSapIndex.vue';

const routes: RouteConfig[] = [
  {
    path: '/pedidos',
    name: 'PedidosSapIndex',
    component: PedidosSapIndex,
    meta: {
      icon: 'mdi-format-list-bulleted',
      rules: [CaslRules.PedidoSap.listar],
    },
  },
];

export default routes;
